<template>
  <div>
    <p v-if="this.$cookies.get('supplier_id')" align="right">
      <el-button type="text" @click="showAgreement">订单合同</el-button>
    </p>
    <div class="order-detail" v-loading="loading">
      <div class="table_outDiv">
        <table class="table table-hover first_table">
          <tbody>
            <tr>
              <td>订单编号：</td>
              <td class="b">{{orderinfo.order_number||''}}</td>
              <td>订单状态：</td>
              <td>
                <el-tag
                  size="mini"
                  v-if="orderinfo.refund_status==0||orderinfo.refund_status==3||orderinfo.refund_status==4"
                >{{orderinfo.order_status|statusType}}</el-tag>
                <el-tag v-else type="danger" size="mini">{{orderinfo.refund_status|refundType}}</el-tag>
              </td>
            </tr>
            <tr>
              <td>店铺名称：</td>
              <td>{{orderinfo.supplier_address&&orderinfo.supplier_address.name||''}}</td>
              <td>租期：</td>
              <td>{{orderinfo.time_interval||''}}</td>
            </tr>
            <tr>
              <td>租赁开始时间：</td>
              <td>{{orderinfo.start_time}}</td>
              <td>租赁结束时间：</td>
              <td>{{orderinfo.end_time}}</td>
            </tr>
            <tr>
              <td>终端设备：</td>
              <td>
                <el-tag
                  size="mini"
                  :type="orderinfo.source|sourceColorType"
                >{{orderinfo.source|sourceType}}</el-tag>
              </td>
              <td>取货方式：</td>
              <td>
                <el-tag
                  size="mini"
                  :type="orderinfo.shipping_type|shippingTypeColorType"
                >{{orderinfo.shipping_type|shippingType}}</el-tag>
              </td>
            </tr>
            <tr>
              <td>实际支付：</td>
              <td class="b">¥{{orderinfo.amount||'0.00'}}</td>
              <td>支付方式：</td>
              <td>
                <el-tag
                  size="mini"
                  :type="orderinfo.pay_method|payMethodColorType"
                >{{orderinfo.pay_method|payMethodType}}</el-tag>
              </td>
            </tr>
            <tr>
              <td>合计租金：</td>
              <td>¥{{orderinfo.total_rent||'0.00'}}</td>
              <td>运费：</td>
              <td>¥{{orderinfo.freight||'0.00'}}</td>
            </tr>
            <tr>
              <td>实付押金：</td>
              <td>¥{{orderinfo.actually_pay_deposit||'0.00'}}</td>
              <td v-if="orderinfo.is_delivery_online&&isSupplier">闪送方式：</td>
              <td v-if="orderinfo.is_delivery_online&&isSupplier">
                <el-tag
                  size="mini"
                  type="warning"
                >{{orderinfo.is_delivery_online|deliveryOnlineType}}</el-tag>
              </td>
              <td v-if="!orderinfo.is_delivery_online"></td>
              <td v-if="!orderinfo.is_delivery_online"></td>
            </tr>
            <tr>
              <td>原押金：</td>
              <td>¥{{orderinfo.pay_deposit||'0.00'}}</td>
              <td>减免押金：</td>
              <td>¥{{orderinfo.free_deposit||'0.00'}}</td>
            </tr>
            <tr>
              <td>下单时间：</td>
              <td>{{orderinfo.create_time||''}}</td>
              <td>付款时间：</td>
              <td>{{orderinfo.pay_time||''}}</td>
            </tr>
            <tr>
              <td>发货时间：</td>
              <td>{{orderinfo.shipping_time||''}}</td>
              <td>收货时间：</td>
              <td>{{orderinfo.shipping_end_time||''}}</td>
            </tr>
            <tr>
              <td>归还时间：</td>
              <td>{{orderinfo.back_time||''}}</td>
              <td>押金退还时间：</td>
              <td>{{orderinfo.deposit_back_time||''}}</td>
            </tr>
          </tbody>
        </table>
        <table class="table table-hover first_table last_table" v-if="orderinfo.return_info">
          <thead>
            <th colspan="4" style="background:rgba(255,107,86,0.2)">归还信息</th>
          </thead>
          <tbody>
            <tr>
              <td>归还方式：</td>
              <td>
                <el-tag size="mini" :type="orderinfo.return_info.type|returnTypeColor">{{orderinfo.return_info.type|returnType}}</el-tag>
              </td>
              <td>归还时间：</td>
              <td>{{orderinfo.return_info.back_time}}</td>
            </tr>
            <tr v-if="orderinfo.return_info.type==1">
              <td>快递公司：</td>
              <td>{{orderinfo.return_info.delivery_company}}</td>
              <td>运单号：</td>
              <td>{{orderinfo.return_info.tracking_no}}</td>
            </tr>
            <tr v-else>
              <td>归还者姓名：</td>
              <td>{{orderinfo.return_info.name}}</td>
              <td>手机号：</td>
              <td>{{orderinfo.return_info.mobile}}</td>
            </tr>
          </tbody>
        </table>
        <table v-if="Object.keys(orderinfo).length>0" class="table table-hover yzy-table">
          <thead style="background:rgba(249,181,11,0.1)">
            <th>图片</th>
            <th>商品名称/配置</th>
            <th>套餐</th>
            <th>单价</th>
            <th>数量</th>
            <th>押金</th>
            <th>已减免</th>
            <th>优惠券减免</th>
            <th>实付</th>
            <th>状态</th>
            <th>拒绝原因</th>
          </thead>
          <tbody v-for="(v,index1) in orderinfo.goods_info" :key="index1">
            <tr>
              <td>
                <img :src="v.cover_image" alt="">
              </td>
              <td>
                <div class="line2 goods_name" :title="v.goods_name">{{v.goods_name}}</div>
              </td>
              <td :title="v.config_name">{{v.config_name}}</td>
              <td v-if="orderinfo.first_order==1">
                <p class="c9 line-through">¥{{v.origin_goods_price}}</p>
                <p class="red">¥{{v.goods_price}}</p>
              </td>
              <td v-else-if="!orderinfo.pid">¥{{v.goods_price}}</td>
              <td v-else-if="orderinfo.pid">
                <el-tooltip class="item" effect="dark" :content="v.discounts" placement="top-start">
                  <span>¥{{v.goods_price}}</span>
                </el-tooltip>
              </td>
              <td>{{v.goods_num}}</td>
              <td>¥{{v.deposit}}</td>
              <td>¥{{v.deposit_reduction}}</td>
              <td>{{v.coupon_amount?('¥'+v.coupon_amount):'-'}}</td>
              <td>¥{{v.amount}}</td>
              <td v-if="v.is_refund==0">{{orderinfo.order_status|statusType}}</td>
              <td v-else-if="v.is_refund==1">退款中</td>
              <td v-else-if="v.is_refund==2">已退款</td>
              <td v-else-if="v.is_refund==3">
                <p>{{orderinfo.order_status|statusType}}</p>
                <p class="c9 f12 mt5">（拒绝退款）</p>
              </td>
              <td v-else-if="v.is_refund==4">
                <p>{{orderinfo.order_status|statusType}}</p>
                <p class="c9 f12 mt5">（已取消退款）</p>
              </td>
              <td>
                <el-tooltip
                  v-if="v.is_refund==3&&v.refuse_cause"
                  effect="dark"
                  :content="v.refuse_cause"
                  placement="top-end"
                >
                  <span class="c9 f12">查看</span>
                </el-tooltip>
                <span v-else>--</span>
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td colspan="11" class="text-overflow" style="text-align:left;">
                留言：
                <span class="c9 f12" :title="orderinfo.message||''">{{orderinfo.message||''}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table v-if="orderinfo.coupon_info" class="table table-hover first_table last_table">
          <thead>
            <th colspan="4" style="background:rgba(255,107,86,0.2)">优惠券</th>
          </thead>
          <tbody>
            <tr>
              <td>优惠券名称：</td>
              <td>{{orderinfo.coupon_info.coupon_name}}</td>
              <td>优惠券面额：</td>
              <td>
                满
                <span class="use-condition">{{orderinfo.coupon_info.use_condition}}</span>
                元减
                <span
                  class="coupon-amount"
                >{{orderinfo.coupon_info.coupon_amount}}</span>
                元
              </td>
            </tr>
            <tr>
              <td>优惠券有效期：</td>
              <td
                colspan="3"
              >{{orderinfo.coupon_info&&(orderinfo.coupon_info.start_time+' 至 '+orderinfo.coupon_info.end_time)||''}}</td>
            </tr>
          </tbody>
        </table>
        <table class="table table-hover first_table last_table">
          <thead>
            <th colspan="4" style="background:rgba(255,107,86,0.2)">买家信息</th>
          </thead>
          <tbody>
            <tr>
              <td>收货人：</td>
              <td>{{orderinfo.user_address&&orderinfo.user_address.consignee||''}}</td>
              <td>联系方式：</td>
              <td>{{orderinfo.user_address&&orderinfo.user_address.mobile||''}}</td>
            </tr>
            <tr v-if="orderinfo.shipping_type==2||orderinfo.shipping_type==3">
              <td>收货地址：</td>
              <td colspan="3">{{orderinfo.user_address&&orderinfo.user_address.address_details||''}}</td>
            </tr>
            <tr>
              <td>身份证姓名：</td>
              <td>{{orderinfo.user_info&&orderinfo.user_info.idcard_name||''}}</td>
              <td>身份证号：</td>
              <td>{{orderinfo.user_info&&orderinfo.user_info.idcard_number||''}}</td>
            </tr>
          </tbody>
        </table>
        <table class="table table-hover first_table last_table">
          <thead>
            <th colspan="4" style="background:rgba(255,107,86,0.2)">店铺信息</th>
          </thead>
          <tbody>
            <tr>
              <td>店铺名称：</td>
              <td>{{orderinfo.supplier_address&&orderinfo.supplier_address.name||''}}</td>
              <td>昵称：</td>
              <td>{{orderinfo.supplier_address&&orderinfo.supplier_address.nickname||''}}</td>
            </tr>
            <tr>
              <td>联系电话：</td>
              <td>{{orderinfo.supplier_address&&(orderinfo.supplier_address.supplier_admin_phone||orderinfo.supplier_address.mobile)}}</td>
              <td>地址：</td>
              <td
                :title="orderinfo.supplier_address&&orderinfo.supplier_address.address_details||''"
              >{{orderinfo.supplier_address&&orderinfo.supplier_address.address_details||''}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <el-dialog
        class="yzy-dialog"
        :append-to-body="true"
        :visible.sync="agreementVisible"
        width="1100px"
        top="50px"
      >
        <el-button type="text" class="download-btn" @click="downloadAction">下载</el-button>
        <rental-com :orderinfo="orderinfo"/>
        <rental v-show="false" class="word" :orderinfo="orderinfo"/>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { orderinfo } from "../api/order/order";
import rentalCom from "../components/rentalCom";
import rental from "../components/rental";
import saveAs from "file-saver";
import "../../static/js/jquery.wordexport.js";
export default {
  name: "orderDetails",
  data() {
    return {
      orderinfo: {},
      provinceList: ["北京", "天津", "重庆", "上海"],
      loading: false,
      isSupplier: this.$cookies.get("supplier_id"),

      orderDetailVisible: false,
      agreementVisible: false
    };
  },
  components: {
    rentalCom,
    rental
  },
  methods: {
    downloadAction() {
      $(".word").wordExport("订单合同");
    },
    showAgreement() {
      this.agreementVisible = true;
    },
    goodsmanage() {
      this.$emit("locl", true);
    },
    getorderinfo() {
      this.loading = true;
      let param = {
        user_id: this.$cookies.get("uid"),
        order_id: localStorage.getItem("orderid")
      };
      orderinfo(param).then(response => {
        this.loading = false;
        if (response.data.code != "error") {
          if (
            response.data.data.goods_info &&
            response.data.data.goods_info.length > 0
          ) {
            response.data.data.goods_info.map(v => {
              v.time_interval = response.data.data.time_interval;
            });
          }
          if (response.data.data.pid) {
            this.$emit("pid", response.data.data.pid);
          }
          this.orderinfo = response.data.data;
        }
      });
    }
  },
  filters: {
    statusType(state) {
      const obj = {
        0: "待付款",
        1: "待发货",
        2: "待收货",
        3: "待归还",
        4: "已完成",
        5: "已取消",
        6: "已续租"
      };
      return obj[state];
    },
    refundType(state) {
      const obj = {
        1: "已退款",
        2: "退款中",
        3: "待发货（拒绝退款）",
        4: "已取消"
      };
      return obj[state];
    },
    isRefundType(state) {
      const obj = {
        1: "退款中",
        2: "已退款",
        3: "待发货（拒绝退款）",
        4: "已取消"
      };
      return obj[state];
    },
    shippingTypeColorType(status) {
      const statusMap = {
        1: "primary",
        2: "success",
        3: "warning",
        4: "primary"
      };
      return statusMap[status];
    },
    shippingType(state) {
      const obj = {
        1: "押金自提",
        2: "同城闪送",
        3: "顺丰",
        4: "身份证自提"
      };
      return obj[state];
    },
    payMethodType(status) {
      const statusMap = {
        0: "钱包",
        1: "支付宝",
        2: "微信",
        null: "无"
      };
      return statusMap[status];
    },
    payMethodColorType(status) {
      const statusMap = {
        0: "primary",
        1: "warning",
        2: "success",
        null: "info"
      };
      return statusMap[status];
    },
    sourceType(status) {
      const statusMap = {
        0: "IOS",
        1: "PC",
        2: "Android",
        4: "微信小程序",
        5: "百度小程序"
      };
      return statusMap[status];
    },
    sourceColorType(status) {
      const statusMap = {
        0: "primary",
        1: "success",
        2: "warning",
        4: "danger",
        5: "info"
      };
      return statusMap[status];
    },
    deliveryOnlineType(status) {
      const obj = {
        0: "平台线上通知闪送取件",
        1: "店铺线下通知闪送取件"
      };
      return obj[status];
    },
    returnType(status){
      const obj = {
        1: "物流归还",
        2: "自己归还"
      };
      return obj[status];
    },
    returnTypeColor(status){
      const obj = {
        1: "success",
        2: "warning"
      };
      return obj[status];
    }
  },
  created() {
    // this.getorderinfo();
  }
};
</script>
<style scoped>
.order-detail {
  border: 1px solid #e6e6e6;
  border-top: 0;
}
.order-detail table {
  width: 100%;
  font-size: 14px;
}
.order-detail table tr {
  padding: 15px 0;
}
.order-detail table tr td img {
  width: 40px;
  height: 40px;
}
.table {
  margin-bottom: 0;
}
.first_table tbody tr td:first-child {
  width: 10%;
  white-space: nowrap;
}
.first_table tbody tr td:nth-child(3) {
  width: 12%;
  white-space: nowrap;
}
.last_table tbody tr td:nth-child(2) {
  width: 40%;
  white-space: nowrap;
}
.table th,
.table td {
  line-height: 20px;
  border-top: 1px solid #e6e6e6;
  color: #555;
  padding: 0.45rem;
}
.yzy-table th {
  text-align: center;
}
.yzy-table td {
  padding: 10px 5px;
  max-width: 200px;
  line-height: 1;
  vertical-align: middle;
  text-align: center;
}
.table thead th {
  border-bottom: 0;
}
.table tbody + tbody {
  border-top: 0;
}
.table td.b {
  color: red;
}
.goods_name {
  /* text-align: left; */
}
.use-condition {
  color: #ff6b56;
  font-weight: bold;
}
.coupon-amount {
  font-size: 14px;
  font-weight: bold;
  color: #eb2525;
}
</style>
<style>
.yzy-dialog .el-dialog__body {
  border-top: 0 !important;
}
.yzy-dialog .el-dialog__body p {
  margin: 0;
}
.download-btn {
  position: absolute;
  right: 100px;
  top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/orderDetails.vue